import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    angular.module('app').directive('minMaxValidator', minMaxValidator);

    function minMaxValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function minMaxValidator(ngModelValue) {
                    var message = attr.minMaxValidatorMessage;

                    if (!ngModelValue) {
                        ctrl.$setValidity(message, true);
                        return ngModelValue;
                    }

                    var isValid = true;
                    var valueDecimal = new Decimal(ngModelValue.value);

                    var minValue = scope.$eval(attr.minValue);
                    if (!!minValue) {
                        if (valueDecimal.lessThan(minValue.value)) {
                            isValid = false;
                        }
                    }

                    var maxValue = scope.$eval(attr.maxValue);
                    if (!!maxValue) {
                        if (valueDecimal.greaterThan(maxValue.value)) {
                            isValid = false;
                        }
                    }

                    ctrl.$setValidity(message, isValid);

                    return ngModelValue;
                }

                ctrl.$parsers.push(minMaxValidator);
            }
        };
    }
})();
